import {
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  Box,
} from "@material-ui/core";
import { FILE_ICON } from "asset/images";
import React, { useState } from "react";
import MoreVerticalDot from "../../academicPlanDetails/MoreVerticalDot";
import EditIcon from "@mui/icons-material/Edit";
import { deepPurple } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  cardBody: {
    margin: "1rem",
    background: "#F0F2FE",
    borderRadius: "15px",
    boxShadow: "none",
    marginTop: "50px",
  },
  cardContent: {
    padding: "26px 18px !important",
  },
  cardTitle: {
    fontStyle: "normal",
    fontWeight: "800",
    fontSize: "18px",
    lineHeight: "22px",
    color: "#263657",
    display: "flex",
    alignItems: "center",
  },
  fileIcon: {
    marginRight: "10px",
  },
  cardTitleWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  subTitle: {
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "8px",
    lineHeight: "10px",
    color: "#898EAC",
  },
  cardBodyContent: {
    marginTop: "18px",
  },
  bodyText: {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#000000",
  },
  dotStyle: {
    width: "3.86px",
    height: "3.86px",
    background: "#898EAC",
    borderRadius: "50%",
    display: "inline-block",
    verticalAlign: "middle",
    margin: "auto 7px",
  },
  inputFormControl: {
    margin: "1.5rem",
  },
  flexGrid: {
    "&.MuiGrid-root": {
      display: "flex",
    },
  },
  inputLabel1: {
    top: "-17px",
    left: "-14px",
  },
  inputLabel: {
    top: "-17px",
  },
  placeholderValue: {
    color: "#bbb",
  },
  avatar: {
    background: deepPurple[500],
    height: "24px",
    width: "24px",
    marginRight: "10px",
    fontSize: "16px",
  },
  cardBottom: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  createdBy: {
    display: "flex",
    flexDirection: "column",
  },
  createdBySection: {
    display: "flex",
    marginTop: "18px",
  },
  statusBlock: {
    marginTop: "18px",
  },
  modifyIcons: {
    width: "65px",
    textAlign: "end",
  },
  editIcon: {
    marginRight: "10px",
  },
}));

function StaffDetailCard({ data, privileges, isDetailedPage }) {
  const classes = useStyles();
  const [modalState, setModalState] = useState({
    isOpen: false,
    data: null,
    isEdit: false,
  });
  return (
    <>
      <Box sx={{ minWidth: 275 }}>
        <Card elevation="0" className={classes.cardBody}>
          <CardContent className={classes.cardContent}>
            <div className={classes.cardTitleWrapper}>
              <Typography className={classes.cardTitle} variant="div">
                <img
                  className={classes.fileIcon}
                  src={FILE_ICON}
                  alt="File Icon"
                />
                <span>{data?.fullName || "-"}</span>
              </Typography>
              {privileges?.UPDATE && (
                <div className={classes.verticalDotsButton}>
                  <MoreVerticalDot
                    options={[
                      {
                        icon: (
                          <EditIcon
                            fontSize="small"
                            className={classes.editIcon}
                          />
                        ),
                        label: "Manage Staff",
                        value: "Manage Staff",
                      },
                    ]}
                    handleClick={(e) => {
                      e.stopPropagation();
                      setModalState((prev) => ({
                        ...prev,
                        isOpen: true,
                        isEdit: true,
                        data,
                      }));
                    }}
                    background={"#fff"}
                  />
                </div>
              )}
            </div>

            <div className={classes.cardBodyContent}>
              <Typography className={classes.bodyText} variant="div">
                Designations:{" "}
                <Typography className={classes.bodySubText} variant="div">
                  {data?.designation || "-"}
                </Typography>
              </Typography>
            </div>
            <div>
              <Typography className={classes.bodyText} variant="span">
                Mobile:{" "}
                <Typography className={classes.bodySubText} variant="div">
                  {data?.mobile || "-"}
                </Typography>
              </Typography>
            </div>
            <div>
              <Typography className={classes.bodyText} variant="span">
                School:{" "}
                <Typography className={classes.bodySubText} variant="div">
                  {data?.school?.schoolCampus || "-"}
                </Typography>
              </Typography>
            </div>
            <div>
              <Typography className={classes.bodyText} variant="span">
                Address:{" "}
                <Typography className={classes.bodySubText} variant="div">
                  {data?.permanentAddress || "-"}
                </Typography>
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

export default StaffDetailCard;
